import color from "../../../../constants/color";

const styles = {
  mainHeading: {
    fontSize: "20px",
    fontWeight: "600",
  },
  mainBox: {
    width: "100%",
    m: "16px",
    display: {xs: "block", lg: "flex"},
    justifyContent: "space-between",
    alignItems: "baseline"
  },
  whiteSection: {
    mx: "16px",
    mb: "28px",
    p: "0px !important",

    backgroundColor: color.card,
    px: "20px",
    pb: "30px",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "space-between",
    mt: 0,
  },

  downloadIcon: {
    mr: 1, 
    fontSize: "4px",
  },
  downloadbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: "#28AA4A",
    // ml: { xs: 0, md: "10px" }, 
    // my: 4,
    fontSize: "12px",
    px: 3,
  },

  printbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: color.lightText,
    mr:  "10px", 
    // my: 4,
    fontSize: "12px",
    px: 3,

  },
  exportbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: color.secondary,
    mr: "10px", 
    // my: 4,
    fontSize: "12px",
    px: 3,

  },
  gridBox: {
    p: 6,
    width: "100%",
  },
  payslipHeading: {
    fontWeight: "700",
  },
  payslipDate: {
    fontWeight: "500",
    fontSize: "12px",
  },
  line: {
    border: "1px solid #DEDEDE",
    width: "100%",
    my: 1,
  },
  lines: {
    border: "1px solid #DEDEDE",
    width: "100%",
    mb: 2.5,
  },

  pixelText: {
    fontSize: "12px",
    fontWeight: "600",
  },
  pixelTextTo: {
    fontSize: "12px",
    fontWeight: "600",
    mt: 2,
  },
  earningGrid: {
    display: "flex",
    justifyContent: "space-between",
    my: 2,
  },
  earningHeading: {
    fontSize: "16px",
    fontWeight: "700",
    pb: 2.5,

  },
  earningInfo: {
    display: "flex",
    justifyContent: "space-between",


  },
  infoText: {
    fontWeight: "600",
    fontSize: "14px",
  },
  infoValue: {
    fontWeight: "500",
    fontSize: "14px",
  },
  netSalary: {
    fontWeight: "700",
    fontSize: "18px",

  },


  introText: {
    fontSize: "12px",
    fontWeight: "400",
  },
  profileAvtar: {
    my: 2,
  },
  profileGrid: {
    display: {xs: "block", lg: "flex"},
    justifyContent: "space-between",
  },
  lastBox: {
    textAlign: "end",
  },

  
}
export default styles
  

